import React, { FC } from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import ItemSelector from './ItemSelector'
import { VariationSelectorProps } from '../typings'

const VariationSelector: FC<VariationSelectorProps> = ({
  variation,
  selectedItem,
  askToSelectVariation,
  designTokens,
}) => {
  return (
    <div
      id={`vtex-sku-selector__${variation.name}`}
      className={csx({
        '.selector-container': {
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '2rem',
        },
        '.selector-name-container': {
          margin: '.125rem',
        },
        '.selector-name': {
          display: 'block',
          overflow: 'hidden',
          marginBottom: '.5rem',
        },
        '.item-selector': {
          display: 'inline-flex',
          flexWrap: 'wrap',
        },
        '.label-text': {
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '-0.02em',
          color: '#000000',
          fontWeight: 500,
        },
      })}
    >
      <div
        className={
          (designTokens && designTokens.skuSelectorContainer) ||
          'vtex-sku-selector__container selector-container'
        }
      >
        <div className="vtex-sku-selector__name-container selector-name-container">
          <Text className="vtex-sku-selector__name selector-name">
            <Text variant="title1" className="label-text">
              {variation.name}
            </Text>
            {askToSelectVariation ? (
              <Text className="c-danger ml3 t-mini">
                <FormattedMessage id="sku-selector.select-warning" />{' '}
                {variation.name}
              </Text>
            ) : null}
          </Text>
          <div className="item-selector">
            {variation.items.map((item, i) => (
              <ItemSelector
                selected={selectedItem === item.label}
                key={i}
                handleSelect={item.onSelectItem}
                label={item.label}
                thumbSrc={item.thumbSrc}
                isAvailable={item.available}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default VariationSelector
